
















































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import StatementMonthly from "@/components/statements/Monthly.vue";
import StatementNone from "@/components/statements/None.vue";

import {mapGetters} from "vuex";
import StatementApi from "@/consoleapi/api/statement";
import store from '@/store'

@Component({
    components: {
        StatementMonthly,
        StatementNone
    },
    computed:
        mapGetters({
            progress:'statement/progress'
        }),
})

export default class Statement extends Vue {
    public year = "";
    public month = "";
    public charges = [];
    public total = 0;
    public updateTime = "";
    private thisYear = 2000;
    // private thisMonth = 0;

    private progress: string | null | undefined;

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    @Emit()
    public inputYearEmit(inputYear: string) {
        this.year = inputYear;
        //console.log(inputYear);
    }

    @Emit()
    public inputMonthEmit(inputMonth: string) {
        this.month = inputMonth;
        //console.log(inputMonth);
    }

    private get inputYear(): string {
        return this.year;
    }

    private set inputYear(year: string) {
        this.inputYearEmit(year);
    }

    private get inputMonth(): string {
        return this.month;
    }

    private set inputMonth(month: string) {
        this.inputMonthEmit(month);
    }

    pushMonthly() {
        if (!this.validation()) {
            return;
        }
        this.getMonthly();
    }

    getMonthly(){
        const statement = new StatementApi();
        statement.setBearerToken(this.bearerToken);
        statement.showMonthly(this.accountId, this.year, this.month).then(response => {
            this.charges = response.data.charges;
            this.total = response.data.total;
            this.updateTime = "更新日時: " + response.data.updated_at.date.substr(0, 16);
            if(this.charges.length){
                store.dispatch('statement/pushProgress', 'monthly');
            } else {
                store.dispatch('statement/pushProgress', 'none');
            }
        }).catch(error => {
            store.dispatch('statement/pushProgress', 'none');
            //console.log(error.response);
        });
    }

    validation() {
        if (!this.year || !this.month) {
            alert('利用年月を選択してください。');
            return false;
        }
        return true;
    }

    mounted() {
        store.dispatch('statement/pushProgress', 'index');
        const today = new Date(); // 変数が呼ばれた時の日時がDate型で取得できる
        this.thisYear = today.getFullYear(); // 2019とかを取得できる
        // const thisMonth = today.getMonth();
    }

    private calcYear(index: number){
        return Number(this.thisYear) - index + 1;
    }
}
